import { Option } from 'shared/components/Select/models/Option';
import { mapBuildingHouseType } from 'shared/constants/filters/mapBuildingHouseType';
import { EBuidlingHouseLine } from 'shared/types/filters/advanced/buildlingHouseLine';

export const buildingHouseLineOptions = [
  new Option(EBuidlingHouseLine.First, mapBuildingHouseType[EBuidlingHouseLine.First]),
  new Option(EBuidlingHouseLine.Second, mapBuildingHouseType[EBuidlingHouseLine.Second]),
];
